import { Fragment, h } from "preact";
import { ButtonPrimary } from '../../../_common/components/buttons/buttons'
import {useLocation, useParams} from 'react-router'
import SusceptibleApi from '../../../_api/fct/src/api/SusceptibleApi'
import Banner from "../../../_common/components/Banner";
import { t } from "../../../_i18n";
import { Card } from "../../../_common/layout";
import { RadioCheckbox } from "../../../_common/forms/components/components";

export default function Susceptible () {

  const { id } = useParams()

  function accept() {
    const api = new SusceptibleApi()
    const response = api.apiV1MyaccountSusceptibleContractIdAcceptPostWithHttpInfo(id)
    response.then(function(response_and_data) {
      window.location.href = '/'
    });
  }

  function refuse() {
    const api = new SusceptibleApi()
    const response = api.apiV1MyaccountSusceptibleContractIdRefusePostWithHttpInfo(id)
    response.then(function(response_and_data) {
      window.location.href = '/'
    });
  }

  return (
    <Fragment>
      <Card smOnly={false} class="p-x2-bottom">
        <p class='m-bottom'>Ya cumples los requisitos para cursar <span className="font-bold">la FFE (fase de formación en empresa)</span>:
          tienes más del 30% de las asignaturas superadas y la asignatura de itinerario para la empleabilidad I
          aprobada.</p>
        <p>Necesitamos saber si tienes <span className="font-bold">intención de cursarlas</span> este próximo curso
          escolar.</p>

        <Banner icon={'info-circle'} class="m-x2-bottom m-top-x2 d-flex flex-baseline-y">
          <h3 className="text-responsive m-bottom">Es importante que sepas: </h3>
          <p dangerouslySetInnerHTML={{ __html: t('commitmentFct') }}></p>
        </Banner>
        <div class='d-flex gap-1'>
          <RadioCheckbox
            label={t('Si, (iniciar FFE)')}
            type='radio'
            onChange={() => accept()}
          />
          <RadioCheckbox
            label={t('No, (no matricular)')}
            type='radio'
            onChange={() => refuse()}
          />
        </div>

      </Card>
    </Fragment>
  );
}
